import instance from "./axios.base";

const getLunarSigns = async () => {
  const res = await instance.get("/lunarsign");
  return res.data;
};

export { getLunarSigns };
